/**
 * Bottom nav for the mob PWA. Two tabs today: Inbox (research URLs) and
 * Productions (research-trigger / write flow). Designed for Flip 7
 * one-handed reach — tap targets are 64px tall to clear thumb-zone-error
 * margins on a folded form factor.
 */
import { Link, useLocation } from 'react-router-dom';
import { Newspaper, Library } from 'lucide-react';

type Tab = 'inbox' | 'productions';

export function BottomNav({ active }: { active?: Tab }) {
  const location = useLocation();
  // Auto-detect active if not explicitly passed
  const current: Tab =
    active ??
    (location.pathname.startsWith('/productions') ? 'productions' : 'inbox');

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-20 bg-bg/95 backdrop-blur border-t border-border"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex">
        <NavTab to="/" label="Inbox" icon={<Newspaper className="h-5 w-5" />} active={current === 'inbox'} />
        <NavTab
          to="/productions"
          label="Productions"
          icon={<Library className="h-5 w-5" />}
          active={current === 'productions'}
        />
      </div>
    </nav>
  );
}

function NavTab({
  to,
  label,
  icon,
  active,
}: {
  to: string;
  label: string;
  icon: React.ReactNode;
  active: boolean;
}) {
  return (
    <Link
      to={to}
      className={`flex-1 flex flex-col items-center justify-center gap-1 py-3 transition-colors ${
        active ? 'text-accent' : 'text-muted'
      }`}
    >
      {icon}
      <span className="text-xs font-medium">{label}</span>
    </Link>
  );
}
